import React, { useState } from 'react';
import { Box, Grid2 as Grid } from '@mui/material';
import { AppState } from '../../types/AppState';
import { useAppSelector } from '../../hooks';
import { unknownGroup } from '../../constants/Group';
import { Page } from '../library/Page';
import { PageHeader } from '../library/PageHeader';
import { ClientDataBranch } from '../../constants/ClientDataBranch';
import { ConfiguratorCard } from '../ConfiguratorCard';
import { hasSuppliers } from '../../utils/supplierUtils';
import { mapClientAndSupplierToClientSupplier } from '../../utils/clientIdUtils';

export const ProductCatalogs: React.FC = () => {
  const configurators = useAppSelector(
    (state: AppState) => (state.currentUser.group || unknownGroup).configurators || [],
  );

  const [initializing, setInitializing] = useState(
    Object.fromEntries(configurators.map(({ clientId }) => [clientId, true])),
  );

  return (
    <Page>
      <PageHeader id="product-catalogs-header" header="Product Catalogs" />
      <Box display="flex" flex={1}>
        <Box width="100%" height="fit-content">
          <Grid
            container
            gap="30px"
            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', alignItems: 'stretch' }}
          >
            {configurators.flatMap((configurator) => {
              const { clientId } = configurator;
              if (!clientId) return [];
              if (hasSuppliers(configurator)) {
                return configurator.suppliers?.map(({ supplierKey }) => {
                  const clientSupplier = mapClientAndSupplierToClientSupplier(clientId, supplierKey);
                  return (
                    <ConfiguratorCard
                      key={clientSupplier}
                      configurator={configurator}
                      clientId={clientSupplier}
                      branch={ClientDataBranch.Pricing}
                      initializing={!!Object.values(initializing).reduce((a, b) => a && b, true)}
                      setInitializing={setInitializing}
                    />
                  );
                });
              }
              return (
                <ConfiguratorCard
                  key={clientId}
                  configurator={configurator}
                  clientId={clientId}
                  branch={ClientDataBranch.Pricing}
                  initializing={!!Object.values(initializing).reduce((a, b) => a && b, true)}
                  setInitializing={setInitializing}
                />
              );
            })}
          </Grid>
        </Box>
      </Box>
    </Page>
  );
};
